export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12792.f3c30079.jpg";